import "@/styles/ua.css";

import { useState } from "react";
import { Navigate, Outlet, useNavigate } from "react-router";

import { PERSONA_NAV } from "./nav-config";
import { PersonaContext } from "./persona-context";
import { Shell } from "./shell";
import type { Persona } from "./types";

function readStoredPersona(): Persona {
  try {
    const stored = localStorage.getItem("ea-shw-persona") as Persona | null;
    if (stored && (Object.keys(PERSONA_NAV) as Persona[]).includes(stored)) {
      return stored;
    }
  } catch {
    // ignore
  }
  return "backoffice";
}

export function DashboardPage() {
  const navigate = useNavigate();

  const [persona, setPersona] = useState<Persona>(readStoredPersona);

  function handlePersonaChange(p: Persona) {
    setPersona(p);
    try {
      localStorage.setItem("ea-shw-persona", p);
    } catch {
      // ignore
    }
    void navigate(`/dashboard/${PERSONA_NAV[p].defaultPage}`);
  }

  return (
    <PersonaContext.Provider value={{ persona, onPersonaChange: handlePersonaChange }}>
      <Shell>
        <Outlet />
      </Shell>
    </PersonaContext.Provider>
  );
}

export function DashboardIndexRedirect() {
  const persona = readStoredPersona();
  return <Navigate to={`/dashboard/${PERSONA_NAV[persona].defaultPage}`} replace />;
}
